import React, { useState } from 'react';
import { Modal, Carousel, CarouselItem, CarouselControl, CarouselIndicators, CarouselCaption, } from 'reactstrap';

function MediaModal(props) {
    const [activeIndex, setActiveIndex] = useState(0);

    const toggle = () => {
        props.setModal(!props.modal)
        setActiveIndex(0)
    };

    const next = () => {
        const nextIndex = activeIndex === props.media.length - 1 ? 0 : activeIndex + 1;
        setActiveIndex(nextIndex);
    };
    
    const previous = () => {
        const nextIndex = activeIndex === 0 ? props.media.length - 1 : activeIndex - 1;
        setActiveIndex(nextIndex);
    };
    
    const goToIndex = (newIndex) => {
        setActiveIndex(newIndex);
    };
    
    const slides = props.media && props.media.map((item) => {
        return item.type=='image' ? (
            <CarouselItem
            key={item.src}
            >
            <img src={item.src} alt={item.altText}  style={{height:'70vh'}}/>
            <CarouselCaption
                captionText={item.caption}
            />
            </CarouselItem>
        )
        : (
        <CarouselItem
        key={item.src}
        >
            <iframe width='100%' 
                style={{height:'70vh'}}
                src={item.src}
                title="YouTube video player" 
                frameBorder="0" 
                allow="accelerometer; 
                clipboard-write; 
                encrypted-media; 
                gyroscope; 
                picture-in-picture" 
                allowFullScreen/>
            <CarouselCaption
                captionText={item.caption}
            />
        </CarouselItem>
        )
    });

  return (
    <Modal isOpen={props.modal} toggle={toggle} className='bg-transparent' >
        <div className='mb--4 bg-transparent'>
        <Carousel
            interval={false}
            activeIndex={activeIndex}
            next={next}
            previous={previous}
            >
            <CarouselIndicators
                items={props.media && props.media}
                activeIndex={activeIndex}
                onClickHandler={goToIndex}
            />
            {slides}
            <CarouselControl
                direction="prev"
                directionText="Previous"
                onClickHandler={previous}
            />
            <CarouselControl
                direction="next"
                directionText="Next"
                onClickHandler={next}
            />
        </Carousel>
        <h2 style={{ position: 'absolute',top: '6%', left: '7%', color:'white'}} >{props.tittle}</h2>
        </div>
    </Modal>
  )
}

export default MediaModal